var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "container-external-api" }
    },
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(
          " " + _vm._s(_vm.fieldDetail ? "EDIT WIDGET" : "ADD WIDGET") + " "
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.type.$error } },
                [
                  _c("label", [_vm._v(" Type ")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "type-row" },
                    _vm._l(_vm.listType, function(type, key) {
                      return _c(
                        "b-col",
                        {
                          key: key,
                          attrs: { md: "3" },
                          on: {
                            click: function($event) {
                              _vm.setWidgetType(type.id)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              class:
                                _vm.dataSetup.type == type.id
                                  ? "type-opt-btn active"
                                  : "type-opt-btn"
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/icon/canvas/" +
                                      type.icon)
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(type.text))])
                              ])
                            ]
                          )
                        ]
                      )
                    })
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.name.$error } },
                [
                  _c("label", [_vm._v(" Name ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required": _vm.$v.dataSetup.name.$error,
                      placeholder: "Enter field name"
                    },
                    model: {
                      value: _vm.$v.dataSetup.name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.dataSetup.name, "$model", $$v)
                      },
                      expression: "$v.dataSetup.name.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form",
                {
                  class: { "error-input": _vm.$v.dataSetup.description.$error }
                },
                [
                  _c("label", [_vm._v(" Description ")]),
                  _vm._v(" "),
                  _c("j-textarea", {
                    attrs: {
                      "error-required": _vm.$v.dataSetup.description.$error,
                      placeholder: "Enter widget description"
                    },
                    model: {
                      value: _vm.$v.dataSetup.description.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.dataSetup.description, "$model", $$v)
                      },
                      expression: "$v.dataSetup.description.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.dataSetup.type === "text"
                ? _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.format_type.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Format ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.listFormat,
                          placeholder: "Select Format",
                          "error-required": _vm.$v.dataSetup.format_type.$error,
                          label: "text"
                        },
                        model: {
                          value: _vm.$v.dataSetup.format_type.$model,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.$v.dataSetup.format_type,
                              "$model",
                              $$v
                            )
                          },
                          expression: "$v.dataSetup.format_type.$model"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form",
                { class: { "error-input": _vm.$v.dataSetup.grid.$error } },
                [
                  _c("label", [_vm._v(" Grid ")]),
                  _vm._v(" "),
                  _c("j-single-select", {
                    attrs: {
                      options: _vm.listGrid,
                      disabled:
                        _vm.dataSetup.type === "map" ||
                        _vm.dataSetup.type === "table",
                      placeholder: "Select Grid",
                      "error-required": _vm.$v.dataSetup.grid.$error,
                      label: "text"
                    },
                    model: {
                      value: _vm.$v.dataSetup.grid.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.dataSetup.grid, "$model", $$v)
                      },
                      expression: "$v.dataSetup.grid.$model"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "6" } }, [
            _c(
              "div",
              [
                _vm.dataSetup.type !== "table"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input":
                            _vm.$v.dataSetup.sourceData.tableGroup.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Table Group ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.tableGroupOptions,
                            placeholder: "Select Table Group",
                            "error-required":
                              _vm.$v.dataSetup.sourceData.tableGroup.$error,
                            "value-format": "object",
                            label: "name"
                          },
                          model: {
                            value:
                              _vm.$v.dataSetup.sourceData.tableGroup.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.sourceData.tableGroup,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.dataSetup.sourceData.tableGroup.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type !== "table"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.sourceData.form.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Table ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            disabled: !_vm.dataSetup.sourceData.tableGroup,
                            options: _vm.tableOptions,
                            placeholder: "Select Table",
                            "error-required":
                              _vm.$v.dataSetup.sourceData.form.$error,
                            "value-format": "object",
                            label: "name"
                          },
                          model: {
                            value: _vm.$v.dataSetup.sourceData.form.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.sourceData.form,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.sourceData.form.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isChart
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.x_axis_field.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" X Axis Value ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.list_field,
                            "error-required":
                              _vm.$v.dataSetup.x_axis_field.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.x_axis_field.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.x_axis_field,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.x_axis_field.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type === "bar_chart"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.x_axis_limit.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" X Axis Limit ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: {
                            "error-required":
                              _vm.$v.dataSetup.x_axis_limit.$error,
                            type: "number",
                            placeholder: "Input Limit"
                          },
                          model: {
                            value: _vm.$v.dataSetup.x_axis_limit.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.x_axis_limit,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.x_axis_limit.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isChart
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.y_axis_field.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Y Axis Value ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.list_field,
                            "error-required":
                              _vm.$v.dataSetup.y_axis_field.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.y_axis_field.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.y_axis_field,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.y_axis_field.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "map"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.marker_icon.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Pin Icon ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listTypeAttachment,
                            "error-required":
                              _vm.$v.dataSetup.marker_icon.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.marker_icon.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.marker_icon,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.marker_icon.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "map"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.marker_location.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Pin Location ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listTypeMaps,
                            "error-required":
                              _vm.$v.dataSetup.marker_location.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.marker_location.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.marker_location,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.marker_location.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "map"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input":
                            _vm.$v.dataSetup.marker_description.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Pin Description ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listTypeText,
                            "error-required":
                              _vm.$v.dataSetup.marker_description.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.marker_description.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.marker_description,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.marker_description.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "text" ||
                _vm.dataSetup.type == "progress_bar"
                  ? _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.selected_value.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Selected Value ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options:
                              _vm.dataSetup.type == "progress_bar"
                                ? _vm.listTypeNumber
                                : _vm.list_field,
                            "error-required":
                              _vm.$v.dataSetup.selected_value.$error,
                            label: "name",
                            placeholder: "Select Column"
                          },
                          model: {
                            value: _vm.$v.dataSetup.selected_value.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.selected_value,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.selected_value.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "table"
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.form_ui.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Form UI ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            "load-options": _vm.loadOptionsFormUI,
                            "is-async": true,
                            "cache-option": false,
                            placeholder: "Select Form UI",
                            "error-required": _vm.$v.dataSetup.form_ui.$error,
                            "value-format": "object",
                            label: "name"
                          },
                          model: {
                            value: _vm.$v.dataSetup.form_ui.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.dataSetup.form_ui, "$model", $$v)
                            },
                            expression: "$v.dataSetup.form_ui.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataSetup.type == "table"
                  ? _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.default_view.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Default View ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.listView,
                            "error-required":
                              _vm.$v.dataSetup.default_view.$error,
                            placeholder: "Select View",
                            "value-format": "object",
                            label: "name"
                          },
                          model: {
                            value: _vm.$v.dataSetup.default_view.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.dataSetup.default_view,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.dataSetup.default_view.$model"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-form",
                  {
                    class: { "error-input": _vm.$v.dataSetup.timeframe.$error }
                  },
                  [
                    _c("label", [_vm._v(" Timeframe ")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.listTimeframe,
                        "error-required": _vm.$v.dataSetup.timeframe.$error,
                        label: "name",
                        placeholder: "Select Timeframe"
                      },
                      model: {
                        value: _vm.$v.dataSetup.timeframe.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.dataSetup.timeframe, "$model", $$v)
                        },
                        expression: "$v.dataSetup.timeframe.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dataSetup.type == "progress_bar"
                  ? _c(
                      "b-form",
                      {
                        class: { "error-input": _vm.$v.dataSetup.color.$error }
                      },
                      [
                        _c("j-color-picker", {
                          attrs: {
                            color: _vm.dataSetup.color,
                            "error-required": _vm.$v.dataSetup.color.$error,
                            label: "Color",
                            picker: "chrome"
                          },
                          model: {
                            value: _vm.dataSetup.color,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup, "color", $$v)
                            },
                            expression: "dataSetup.color"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.dataSetup.type !== "table" &&
            _vm.dataSetup.type !== "progress_bar"
              ? _c(
                  "div",
                  { staticClass: "config-canvas-container m__t--10" },
                  [
                    _c(
                      "div",
                      { staticClass: "config-canvas-container__title" },
                      [_vm._v("Sorting")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.sorting.key.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Sort By ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.variableOptionsClass,
                            placeholder: "Sort by",
                            "error-required":
                              _vm.$v.dataSetup.sorting.key.$error,
                            "value-format": "object",
                            label: "label"
                          },
                          model: {
                            value: _vm.dataSetup.sorting.key,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup.sorting, "key", $$v)
                            },
                            expression: "dataSetup.sorting.key"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form",
                      {
                        class: {
                          "error-input": _vm.$v.dataSetup.sorting.order.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Order By ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.orderOptions,
                            placeholder: "Order by",
                            "error-required":
                              _vm.$v.dataSetup.sorting.order.$error,
                            "value-format": "object",
                            label: "label"
                          },
                          model: {
                            value: _vm.dataSetup.sorting.order,
                            callback: function($$v) {
                              _vm.$set(_vm.dataSetup.sorting, "order", $$v)
                            },
                            expression: "dataSetup.sorting.order"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dataSetup.type !== "table" &&
            _vm.dataSetup.type !== "progress_bar"
              ? _c(
                  "div",
                  { staticClass: "config-canvas-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "config-canvas-container__title" },
                      [_vm._v("Filter")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "config-canvas-container__label m__r--15",
                          class: { active: _vm.modeFilter === "variable" },
                          on: {
                            click: function($event) {
                              _vm.selectTab("variable")
                            }
                          }
                        },
                        [_vm._v("\n            VARIABLE\n          ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "config-canvas-container__label",
                          class: { active: _vm.modeFilter === "function" },
                          on: {
                            click: function($event) {
                              _vm.selectTab("function")
                            }
                          }
                        },
                        [_vm._v("\n            FUNCTION\n          ")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.modeFilter === "variable"
                      ? _c(
                          "div",
                          [
                            _vm._l(_vm.dataSetup.filter, function(data, index) {
                              return _c(
                                "b-row",
                                { key: index, staticClass: "filter-container" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "11" } },
                                    [
                                      _c(
                                        "b-form",
                                        { staticClass: "mb-2" },
                                        [
                                          _c("label", [_vm._v(" Key ")]),
                                          _vm._v(" "),
                                          _c("j-single-select", {
                                            staticClass:
                                              "list-options-variable",
                                            attrs: {
                                              "error-required": false,
                                              options: _vm.variableOptionsClass,
                                              placeholder: "Filter by",
                                              "value-format": "object",
                                              label: "label"
                                            },
                                            model: {
                                              value: data.key,
                                              callback: function($$v) {
                                                _vm.$set(data, "key", $$v)
                                              },
                                              expression: "data.key"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      data.key && data.key.type === "timestamp"
                                        ? _c(
                                            "b-form",
                                            { staticClass: "mb-3" },
                                            [
                                              _c("label", [
                                                _vm._v(" Start Date ")
                                              ]),
                                              _vm._v(" "),
                                              _c("j-datepicker", {
                                                attrs: {
                                                  "error-required": false,
                                                  placeholder: "Start Date",
                                                  format: "MMM dd, yyyy"
                                                },
                                                model: {
                                                  value: data.start_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      data,
                                                      "start_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "data.start_date"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.key && data.key.type === "timestamp"
                                        ? _c(
                                            "b-form",
                                            { staticClass: "mb-3" },
                                            [
                                              _c("label", [
                                                _vm._v(" End Date ")
                                              ]),
                                              _vm._v(" "),
                                              _c("j-datepicker", {
                                                attrs: {
                                                  "error-required": false,
                                                  placeholder: "End Date",
                                                  format: "MMM dd, yyyy"
                                                },
                                                model: {
                                                  value: data.end_date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      data,
                                                      "end_date",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "data.end_date"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      data.key === null ||
                                      data.key.type !== "timestamp"
                                        ? _c(
                                            "b-form",
                                            { staticClass: "mb-3" },
                                            [
                                              _c("label", [_vm._v(" Value ")]),
                                              _vm._v(" "),
                                              _c("j-input", {
                                                attrs: {
                                                  "error-required": false,
                                                  placeholder: "Enter value"
                                                },
                                                model: {
                                                  value: data.value,
                                                  callback: function($$v) {
                                                    _vm.$set(data, "value", $$v)
                                                  },
                                                  expression: "data.value"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer p__l--1",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteFilter(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "config-canvas-container__btn",
                                on: { click: _vm.addFilter }
                              },
                              [_vm._v("\n            + Add\n          ")]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.modeFilter === "function"
                      ? _c(
                          "div",
                          [
                            _vm._l(_vm.dataSetup.filter_function, function(
                              data,
                              index
                            ) {
                              return _c(
                                "b-row",
                                {
                                  key: index,
                                  staticClass: "filter-container w--100"
                                },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { cols: "11" } },
                                    [
                                      _c(
                                        "b-form",
                                        { staticClass: "mb-2" },
                                        [
                                          _c("label", [_vm._v(" Variable ")]),
                                          _vm._v(" "),
                                          _c("j-single-select", {
                                            staticClass:
                                              "list-options-variable",
                                            attrs: {
                                              "error-required": false,
                                              options: _vm.variableOptionsClass,
                                              placeholder: "Filter by",
                                              "value-format": "object",
                                              label: "label"
                                            },
                                            model: {
                                              value: data.key,
                                              callback: function($$v) {
                                                _vm.$set(data, "key", $$v)
                                              },
                                              expression: "data.key"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-form",
                                        { staticClass: "mb-3" },
                                        [
                                          _c("label", [_vm._v(" Function ")]),
                                          _vm._v(" "),
                                          _c("j-single-select", {
                                            staticClass:
                                              "list-options-variable",
                                            attrs: {
                                              "error-required": false,
                                              options: _vm.listFunction,
                                              placeholder:
                                                "Select Function Name",
                                              label: "name"
                                            },
                                            model: {
                                              value: data.value,
                                              callback: function($$v) {
                                                _vm.$set(data, "value", $$v)
                                              },
                                              expression: "data.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex align-items-start justify-content-center mt-2 pl-0 cursor-pointer p__l--1",
                                      attrs: { cols: "1" }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa fa-trash",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteFilterFunction(index)
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "config-canvas-container__btn",
                                on: { click: _vm.addFilterFunction }
                              },
                              [_vm._v("\n            + Add\n          ")]
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dataSetup.type !== "table"
                      ? _c(
                          "b-form",
                          {
                            class: {
                              "error-input":
                                _vm.$v.dataSetup.filterOperator.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" Filter Operator ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.filterOperatorOptions,
                                placeholder: "Filter Operator",
                                "error-required":
                                  _vm.$v.dataSetup.filterOperator.$error,
                                label: "name"
                              },
                              model: {
                                value: _vm.dataSetup.filterOperator,
                                callback: function($$v) {
                                  _vm.$set(_vm.dataSetup, "filterOperator", $$v)
                                },
                                expression: "dataSetup.filterOperator"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "float-right" },
        [
          _c(
            "b-button",
            { staticClass: "btn m__r--5", on: { click: _vm.closeModal } },
            [_vm._v("\n      Close\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            { staticClass: "btn blue", on: { click: _vm.submitForm } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.fieldDetail ? "Update" : "Add") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0934a454", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0934a454","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/canvas/widget/jWidgetForm.vue
// module id = null
// module chunks = 